import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="w-full py-20 px-6 md:px-12 bg-white">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* Left: Text */}
        <div>
          <span
            className="inline-block bg-[#f3eeff] text-[#4a1a6b] text-xs font-bold tracking-[0.3em] uppercase px-4 py-2 rounded-full mb-6"
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            Our History
          </span>
          <h2
            className="text-4xl md:text-5xl font-black uppercase text-gray-900 leading-tight mb-6"
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            About the <span className="text-[#4a1a6b]">Vikings</span>
          </h2>
          <p className="text-gray-600 text-base leading-relaxed mb-4">
            For the past 50 years, the Minnesota Vikings have epitomized winning. The Men in Purple have always been near the top of the division standings. Only four NFL teams have played in more Super Bowls, and one — the Dallas Cowboys — have more playoff appearances.
          </p>
          <p className="text-gray-600 text-base leading-relaxed mb-8">
            From the moment they first took the field, the Vikings began providing their fans with unforgettable moments. From Fran Tarkenton's scrambles to Randy Moss's acrobatic catches, to Adrian Peterson's record-breaking runs — this franchise has always delivered greatness.
          </p>
          <div className="grid grid-cols-3 gap-6 mb-8">
            {[
              { stat: '60+', label: 'Years of History' },
              { stat: '4x', label: 'Super Bowl Appearances' },
              { stat: '19+', label: 'Division Titles' },
            ].map((item) => (
              <div key={item.label} className="text-center">
                <div
                  className="text-3xl font-black text-[#4a1a6b]"
                  style={{ fontFamily: "'Oswald', sans-serif" }}
                >
                  {item.stat}
                </div>
                <div className="text-gray-500 text-xs tracking-wider uppercase mt-1" style={{ fontFamily: "'Oswald', sans-serif" }}>
                  {item.label}
                </div>
              </div>
            ))}
          </div>
          <Link
            to="/team"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3 rounded-full bg-[#4a1a6b] text-white font-bold text-sm tracking-widest uppercase cursor-pointer hover:bg-[#ffd700] hover:text-[#4a1a6b] transition-all duration-300"
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            Read More <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Right: Image Card */}
        <div className="relative">
          <div className="rounded-3xl overflow-hidden bg-[#4a1a6b] p-8 relative">
            <img
              src="https://public.readdy.ai/ai/img_res/aa9408a8e72723cc74d9335fd24ed634.jpg"
              alt="Vikings Team"
              className="w-full h-72 object-cover object-top rounded-2xl mb-6"
            />
            <blockquote
              className="text-white text-xl font-black uppercase leading-snug mb-6"
              style={{ fontFamily: "'Oswald', sans-serif" }}
            >
              &ldquo;Skol Vikings, let&apos;s win this game. Skol Vikings, honor your name. Go get that first down, then get a touchdown. Rock &apos;em, sock &apos;em, fight, fight, fight!&rdquo;
            </blockquote>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-white/20 flex items-center justify-center">
                  <i className="ri-user-line text-white text-lg"></i>
                </div>
                <div>
                  <div className="text-white text-sm font-bold" style={{ fontFamily: "'Oswald', sans-serif" }}>Vikings Fight Song</div>
                  <div className="text-white/50 text-xs" style={{ fontFamily: "'Oswald', sans-serif" }}>Est. 1961</div>
                </div>
              </div>
              <button className="w-10 h-10 flex items-center justify-center rounded-full bg-white/20 text-white hover:bg-[#ffd700] hover:text-[#4a1a6b] transition-colors cursor-pointer">
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
          {/* Decorative element */}
          <div className="absolute -bottom-4 -right-4 w-24 h-24 rounded-full bg-[#ffd700]/20 -z-10"></div>
          <div className="absolute -top-4 -left-4 w-16 h-16 rounded-full bg-[#4a1a6b]/10 -z-10"></div>
        </div>
      </div>
    </section>
  );
}
